import { Metrics } from './chatMetrics';
import { isArborHost } from './isArborHost';
import { reportError } from './reportError';

// Single-responsibility metrics sink for the chat client. Kept separate from
// ChatLogger (which is debug/recording logging only): transports and the
// coordinator call these methods for domain events and this maps them to
// metrics. Per-instance -- it holds timer-correlation state, so each client
// MUST get its own instance (chatManager runs concurrent clients per
// conversation and shared timer state would cross-contaminate).
const NOOP = () => {};
export const noopTelemetry = {
  turnCompleted: NOOP,
  toolExecutionStarted: NOOP,
  toolExecutionFinished: NOOP,
  streamError: NOOP
};
export function createChatTelemetry(mode) {
  if (isArborHost()) return noopTelemetry;
  const toolStartTimes = new Map();
  return {
    turnCompleted() {
      Metrics.counter('turn-completed', {
        mode
      }).increment();
    },
    toolExecutionStarted(toolUseId) {
      toolStartTimes.set(toolUseId, performance.now());
    },
    toolExecutionFinished(toolUseId, toolName, status) {
      const startTime = toolStartTimes.get(toolUseId);
      if (startTime === undefined) return;
      toolStartTimes.delete(toolUseId);
      const elapsed = performance.now() - startTime;
      Metrics.timer('tool-execution-duration', {
        tool_name: toolName,
        status,
        mode
      }).update(elapsed);
    },
    streamError(error) {
      const reason = String(error.type);
      Metrics.counter('stream-error', {
        reason,
        mode
      }).increment();
      const reportable = error.cause instanceof Error ? error.cause : new Error(error.message);
      reportError(reportable, {
        scope: 'stream-error',
        extra: {
          mode,
          error_type: reason
        }
      });
    }
  };
}